import { render, staticRenderFns } from "./BottomBarComponent.vue?vue&type=template&id=b8266b60&"
import script from "./BottomBarComponent.vue?vue&type=script&lang=js&"
export * from "./BottomBarComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports